import api from "@/plugins/api/EntryPoint";

export default {
  async createDistributionOrderSumy(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-sumy/create-distribution-order-sumy",
      params,
      callBackFn
    );
  },
  async createDistributionToOrderSumy(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-sumy/create-distribution-to-order-sumy",
      params,
      callBackFn
    );
  },
  async getSumyAccountDistributionDebt(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-sumy/get-sumy-account-distribution-debt",
      params,
      callBackFn
    );
  },
};
